import { Component } from 'preact';

import Card from '../card';
import Loader from '../loader';
import style from './style.scss';
import DataLine from './data-line';
import RainRateStatus from '../rain-rate-status';

/**
 * The RainSummary component is displayed on the home page as part of the primary live
 * data view. It displays live rainfall information (along with atmospheric pressure).
 *
 * props:
 * - data: A data model object containing the data needed for the view
 * - rainUnit: The current rainfall unit
 * - pressureUnit: The current pressure unit
 * - rainFormatter: A function for formatting rainfall values for display purposes
 * - rainRateFormatter: A function for formatting rain rate values for display purposes
 * - pressureFormatter: A function for formatting pressure values for display purposes
 */

class RainSummary extends Component {

	constructor(props) {
		super(props);

		// todo review during live charts implementation
		this.state = {
			liveRainRate: []
		};
	}

	render(props) {

		const { data, rainUnit, pressureUnit, rainFormatter, rainRateFormatter, pressureFormatter } = props;

		if (!data) {
			return (
				<Card>
					<Loader />
				</Card>
			);
		}

		const pressureTrendPrefix = data.pressureTrend > 0 ? '+' : '';

		return (
			<Card>
				<div class={style.rain_layout}>

					<div class={style.rain_section_left}>
						<div class={style.rain_rate}>
							<RainRateStatus rainRate={data.currentRainRate} description={data.currentConditions} rainUnit={rainUnit} rainRateFormatter={rainRateFormatter} />
						</div>

						<div class={style.rain_hourly_daily}>
							<DataLine label="Rain last hour" value={rainFormatter(data.currentHourlyRain)} unit={` ${rainUnit}`} />
							<DataLine label="Rain today" value={rainFormatter(data.rainToday)} unit={` ${rainUnit}`} />
						</div>
					</div>

					<div class={style.rain_section_right}>
						<div class={style.rain_month_year}>
							<DataLine label="Rain this month" value={rainFormatter(data.rainThisMonth)} unit={` ${rainUnit}`} />
							<DataLine label="Rain this year" value={rainFormatter(data.rainThisYear)} unit={` ${rainUnit}`} />
						</div>

						<div class={style.pressure}>
							<DataLine label="Pressure" value={pressureFormatter(data.currentPressure)} unit={` ${pressureUnit}`} />
							<DataLine label="Trend" value={pressureTrendPrefix + pressureFormatter(data.pressureTrend)} unit={` ${pressureUnit}/hr`} />
						</div>
					</div>

				</div>
			</Card>
		);
	}

}

export default RainSummary;



// WEBPACK FOOTER //
// ./components/live/rain-summary.js